import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import CopyToClipboard from 'react-copy-to-clipboard'
import { LineShareButton } from 'react-share'

import Snackbar from '@material-ui/core/Snackbar'
import { ReactComponent as TwitterLogo } from '../../images/twitter.svg'
import { ReactComponent as LineLogo } from '../../images/line.svg'
import LinkIcon from '@material-ui/icons/Link'
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert'
import awsmobile from '../../aws-exports'
import { useDispatch, useSelector } from 'react-redux'
import alertModules from 'modules/alert'
import { useHistory } from 'react-router-dom'
import { RootState } from 'store'
import XShareButton from 'components/common/XShareButton'

import IconShare from '../../images/redesign/icon_share.svg'
import IconShareWhite from '../../images/redesign/icon_share_white.svg'
import IconSnsLineBlack from '../../images/redesign/icon_sns_line_color.svg'
import IconSnsTwitterBlack from '../../images/redesign/icon_sns_twitter_color.svg'
import IconSnsLinkBlack from '../../images/redesign/icon_sns_link_color.svg'

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

interface Props {
  doorName?: string
  ownerName?: string
  horizontal?: boolean
  description?: string
  style?: React.CSSProperties
}

function generateUrl(via: string) {
  var url = new URL(window.location.toString())
  url.host = new URL(awsmobile.yoor_share_url_base).host

  const params = new URLSearchParams(window.location.search)
  if (params.entries.length) {
    var newParams: string[] = []
    params.forEach((value, key) => {
      if (key == 'via') {
        newParams.push(`via=${via}`)
      } else {
        newParams.push(`${key}=${value}`)
      }
    })

    url.search = '?' + newParams.join('&')
  }

  return url
}

const Ul = styled.ul`
.share-link {
  transition: 0.3s ease;
  cursor: pointer;
  width: 35px;
  height: 35px;
  text-align: center;
  display: block;
  @media (max-width: 640px) {
    width: 28px;
    height: 28px;
  }
  &:hover {
    opacity: 0.4;
  }
}
.share-list-item + .share-list-item {
  margin-top: 12px;
  @media (max-width: 640px) {
    margin-top: 16px;
  }
}
`

export default function ShareButtonView(props: Props) {
  const dispatch = useDispatch()
  const history = useHistory()

  const [copied, setCopied] = useState(false)
  const shareUrl = new URL(window.location.toString().replace(window.location.host, new URL(awsmobile.yoor_share_url_base).host)).toString()

  const text = (() => {
    if (props.doorName && props.ownerName) { return `${props.doorName} - ${props.ownerName}` }
    return ''
  })()

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    setCopied(false)
  }

  return (
    <Ul style={props.style}>
      <li className="share-list-item">
        <XShareButton title={`${text}`} url={shareUrl}>
          <img src={IconSnsTwitterBlack} className="share-image" alt="line" />
        </XShareButton>
      </li>
      <li className="share-list-item">
        <LineShareButton
          title={`${text} ${props.description} #YOOR`}
          url={shareUrl}
          resetButtonStyle={true}
          className="share-link"
        >
          <img src={IconSnsLineBlack} className="share-image" alt="line" />
        </LineShareButton>
      </li>
      <li className="share-list-item">
        <CopyToClipboard
          text={`${shareUrl}`}
          onCopy={() =>
            dispatch(
              alertModules.actions.setAlert({
                text: 'クリップボードにコピーしました',
                severity: 'success'
              })
            )
          }
        >
          <span className="share-link">
            <img src={IconSnsLinkBlack} className="share-image" alt="line" />
          </span>
        </CopyToClipboard>
      </li>
      <Snackbar open={copied} autoHideDuration={2000} onClose={handleClose}>
        <Alert severity="success">クリップボードにコピーしました</Alert>
      </Snackbar>
    </Ul>
  )
}
